import { useNavigate } from '@tanstack/react-router'
import type { FC} from 'react'
import { useEffect } from 'react'

import { useBoundStore } from '../store/store'

function protectRoute(WrappedComponent: FC, isProtected?: boolean) {
  const ProtectRoute = (props: Record<string, unknown>) => {
    const username = useBoundStore(state => state.user.username)
    const navigate = useNavigate()

    useEffect(() => {
      if (!username && isProtected) {
        navigate({ to: '/register' })
      }
    }, [username])

    useEffect(() => {
      document.body.classList.remove('noscroll')
    }, [])

    return <WrappedComponent {...props} />
  }

  return ProtectRoute
}

export default protectRoute
